import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CampaignPlanDetails, CampaignPlanError } from 'components/common/types/CampaignPlan.types';

export interface SharedCampaignPlanState {
  campaignPlanDetails: CampaignPlanDetails | null;
  campaignPlanError: CampaignPlanError | null;
  isLoading: boolean;
}

export const initialState: SharedCampaignPlanState = {
  campaignPlanDetails: null,
  campaignPlanError: null,
  isLoading: false,
};

export const sharedCampaignPlanSlice = createSlice({
  name: 'sharedCampaignPlan',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    changeCampaignPlanDetails: (state, action: PayloadAction<CampaignPlanDetails>) => {
      state.campaignPlanDetails = {
        ...action.payload,
        filterOptions: action.payload.filterOptions ?? state.campaignPlanDetails?.filterOptions,
        touchedPoints: action.payload.touchedPoints ?? state.campaignPlanDetails?.touchedPoints,
        assets: {
          ...action.payload.assets,
          filteredAssets:
            action.payload.assets?.filteredAssets.map((asset) => ({
              ...asset,
              availability: 'InFilter',
            })) || [],
        },
      };
    },
    changeCampaignPlanError: (state, action: PayloadAction<CampaignPlanError | null>) => {
      state.campaignPlanError = action.payload;
    },
    clearSharedCampaignPlan: () => initialState,
  },
});

export const { setIsLoading, changeCampaignPlanDetails, changeCampaignPlanError, clearSharedCampaignPlan } =
  sharedCampaignPlanSlice.actions;

export default sharedCampaignPlanSlice.reducer;
